import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./application/store";
import vuetify from "./plugins/vuetify";
import i18n from "@/plugins/i18n";
import "@/plugins/codemirror.ts";
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
